import { JobTitleView, JobTitleForUnionView } from '../api';

export type JobTitleUI = JobTitleView & JobTitleForUnionView & { isVisible?: boolean };
